import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import Etapas from "../../../Components/CardsPages/Etapas";
import AtendimentoDetalhado from "../../../Components/CardsPages/Atendimento/AtendimentoDetalhado";

import {
    AtendimentoPageProvider,
    useAtendimentoPage,
} from "../../../Context/AtendimentoPage";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { useUserInfor } from "../../../Context/User";

import "../../../Assets/css/pages/placeholder.css";
import Acoes from "../../../Components/CardsPages/Atendimento/Acoes";

import RepasseCaso from "../../../Components/CardsPages/RepasseCaso/ComponenteCaso";
import { faAddressBook } from "@fortawesome/free-solid-svg-icons";
import StatusEtapa from "../../../Components/CardsPages/StatusEtapa";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import {
    AtualizaCasoRepasseDadosController,
    GetCasoRepasseDadosController,
} from "../../../Controllers/Repasse/GestaoDadosRepasse/GestaoDadosRepasse";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IAtendimentoRepasseCaso } from "../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import { useHistoricoContext } from "../../../Context/Historico";
import { IAtendimentoDetalhadoAoCliente } from "../../../Interfaces/AtendimentoCliente/Atendimento/AtendimentoInterfaces";
import KPIAtendimentoCliente from "../../AtendimentoCliente/Atendimento/KPIAtendimentoCliente";
import { ListarGrupoVinculadosPorEtapaController } from "../../../Controllers/Geral/Etapas/EtapasControllers";

interface IRouteParams {
    IDCaso: string;
}
interface IRepassePageProps {
    IDCaso: number;
}

export default function AtendimentoRepasse() {
    const params = useParams<IRouteParams>();
    const idCaso = Number.parseInt(params.IDCaso);

    return (
        <AtendimentoPageProvider ID_CASO={idCaso}>
            <RepassePage IDCaso={idCaso} />
        </AtendimentoPageProvider>
    );
}

function RepassePage(props: IRepassePageProps) {
    const { ID_USUARIO } = useUserInfor().UserInfor;

    const [show, setShow] = useState(false);
    const [modal /*setModal*/] = useState<IComponentModal>();
    const [bloquearAcoes, setBloquearAcoes] = useState(false);

    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoDetalhadoAoCliente;

    const { UserInfor } = useUserInfor();
    const { ReloadHistorico } = useHistoricoContext();

    const {
        value: gestaoRepasseDados,
        execute: updateDadosRepasse,
        loading: gestaoRepasseDadosLoading,
    } = useAsyncEffect(async () => {
        return GetCasoRepasseDadosController(Atendimento.ID_CASO);
    }, [Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO]);

    const { loading: salvando, execute: handleRepasseFinanceiro } =
        useAsyncCallback(async (formData: IAtendimentoRepasseCaso) => {
            AtualizaCasoRepasseDadosController({
                ...formData,
                ID_CASO_REPASSE_DADOS:
                    gestaoRepasseDados?.ID_CASO_REPASSE_DADOS ?? 0,
                ID_CASO: gestaoRepasseDados?.ID_CASO ?? 0,
            }).then(() => {
                updateDadosRepasse();
                ReloadHistorico();
            });
        });

    const { value: lstGruposVinculadosEtapa } = useAsyncEffect(async () => {
        if (Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO) {
            const res = ListarGrupoVinculadosPorEtapaController(
                Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
            );

            return res;
        }
    }, [Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO]);

    const isGrupoVinculado = useMemo(() => {
        return lstGruposVinculadosEtapa?.some((idGrupoVinculado) =>
            UserInfor.GRUPOS.some(
                (g) => g.ID_GRUPO === idGrupoVinculado.ID_GRUPO
            )
        );
    }, [UserInfor.GRUPOS, lstGruposVinculadosEtapa]);

    const initialTab = useMemo(
        () => ({
            Component: () => (
                <RepasseCaso
                    gestaoRepasseDados={gestaoRepasseDados}
                    gestaoRepasseDadosLoading={gestaoRepasseDadosLoading}
                    salvando={salvando}
                    handleRepasseFinanceiro={handleRepasseFinanceiro}
                />
            ),
            icon: faAddressBook,
            key: "#repasseDados",
            name: "Dados Do Repasse",
        }),
        [
            gestaoRepasseDados,
            gestaoRepasseDadosLoading,
            handleRepasseFinanceiro,
            salvando,
        ]
    );

    return (
        <>
            {Atendimento ? (
                <>
                    <div className="col-12 mb-5">
                        <Etapas
                            ID_CATEGORIA={Atendimento.ID_CATEGORIA_ATENDIMENTO}
                            ID_ETAPA={
                                Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                            }
                            finalizado={!!Atendimento.DT_FIM}
                        />
                    </div>
                    {
                        <AtendimentoDetalhado
                            IDCaso={props.IDCaso}
                            Atendimento={Atendimento}
                            // extraTabs={extraTabs}
                            KPICard={() => (
                                <KPIAtendimentoCliente
                                    Atendimento={Atendimento}
                                />
                            )}
                            inicialTab={initialTab}
                            buttons={<></>}
                            adicionalComponent={
                                !AtendimentoPage.bloquearInteracoes &&
                                (Atendimento.ID_USUARIO_RESPONSAVEL ===
                                    UserInfor.ID_USUARIO ||
                                    isGrupoVinculado)
                                    ? (AtendimentoPage.Atendimento
                                          ?.ID_USUARIO_RESPONSAVEL ===
                                          ID_USUARIO ||
                                          isGrupoVinculado) && (
                                          <>
                                              <StatusEtapa
                                                  idEtapaCategoriaAtendimentoTipoCaso={
                                                      Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                  }
                                                  setBloquearAcoes={
                                                      setBloquearAcoes
                                                  }
                                                  idCaso={props.IDCaso}
                                              />
                                              <Acoes
                                                  bloquearAcoes={bloquearAcoes}
                                                  ID_CASO={Atendimento.ID_CASO}
                                                  ID_ETAPA={
                                                      Atendimento.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                  }
                                                  gestaoRepasseDados={
                                                      gestaoRepasseDados
                                                  }
                                                  gestaoRepasseDadosLoading={
                                                      gestaoRepasseDadosLoading
                                                  }
                                                  salvando={salvando}
                                                  handleRepasseFinanceiro={
                                                      handleRepasseFinanceiro
                                                  }
                                              />
                                          </>
                                      )
                                    : ""
                            }
                        />
                    }
                </>
            ) : (
                <div className="text-muted text-center">
                    Atendimento não encontrado
                </div>
            )}
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
